const FormInput = ({
    label,
    name,
    value,
    onChange,
    placeholder,
    color,
    textColor,
    placeholderColor,
    width = "auto",
    height = "auto",
    multiline = false,
    error = "",
    disabled,
    type
  }) => (
    <div
      style={{
        ...formFieldStyle,
        width: width,
        height: height,
      }}
    >
      <label style={labelStyle(textColor)}>{label}</label>
      <div style={inputContainerStyle(color)}>
        {multiline ? (
          <textarea
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            style={inputStyle(placeholderColor)}
            rows={4}
          />
        ) : (
          <input
            type={ type || "text"}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            style={inputStyle(placeholderColor)}
            disabled={disabled}
          />
        )}
      </div>
      {error && (
        <span
          style={{
            color: "red",
            fontSize: "12px",
            fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
          }}
        >
          {error}
        </span>
      )}
    </div>
  );

  export default FormInput;
  
  const formRowStyle = {
    display: "flex",
    gap: "24px",
    width: "100%",
  };
  
  const formFieldStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    flex: "1 1 0",
  };
  
  const labelStyle = (color) => ({
    color,
    fontSize: "12px",
    fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
    fontWeight: "400",
  });
  
  const inputContainerStyle = (color) => ({
    padding: "12px 16px",
    background: "white",
    borderRadius: "8px",
    outline: `1px solid ${color}`,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: "1 1 0",
  });
  
  const inputStyle = (placeholderColor) => ({
    flex: "1 1 0",
    border: "none",
    outline: "none",
    background: "transparent",
    color: "inherit",
    fontSize: "16px",
    fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
    fontWeight: "400",
    lineHeight: "24px",
    "::placeholder": {
      color: placeholderColor,
    },
  });